var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E84142",
    d: "M50 100c27.615 0 50-22.385 50-50S77.615 0 50 0 0 22.385 0 50s22.385 50 50 50Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25 70.938h10.938c1.874 0 2.812 0 3.75-.313.937-.313 1.874-.938 2.5-1.563.624-.624 1.25-1.562 2.187-3.124L58.75 40.624c.938-1.875 1.25-2.5 1.563-3.438a4.336 4.336 0 0 0 0-2.812c0-.85-.513-1.699-1.307-3.012l-.256-.425-5.625-9.688-.355-.625c-1.022-1.802-1.613-2.844-2.458-3.125a4.336 4.336 0 0 0-2.812 0c-.844.281-1.435 1.323-2.457 3.125l-.355.625-24.063 42.188c-1.25 2.187-1.875 3.437-1.875 4.374 0 .938.625 1.876 1.563 2.5.625.626 2.187.626 4.687.626Zm37.188 0H75c2.813 0 4.063 0 4.375-.626.938-.624 1.563-1.562 1.563-2.5 0-.937-.626-2.187-1.876-4.374L72.813 52.5l-.355-.625c-1.022-1.802-1.613-2.844-2.457-3.125a4.336 4.336 0 0 0-2.813 0c-.844.281-1.435 1.323-2.457 3.125-.112.2-.23.407-.355.625l-6.25 10.938c-1.25 2.187-1.875 3.437-1.875 4.374 0 .938.625 1.876 1.25 2.5.625.626 2.188.626 4.688.626Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.d4956acb40c598691af4561ccd8835af.svg";
export { ForwardRef as ReactComponent };